module.exports = __webpack_public_path__ + "static/media/vtsl-logo.8ea936d9.png";